module.exports = __webpack_public_path__ + "img/Newbie_Axe_04_Mage.eeaf1af4.png";